/**
 * Company Search Sort Component
 *
 * This is a domain-specific wrapper around the generic MobileSortPanel.
 * It provides the sort options specific to company/location search.
 */

import React from 'react'
import { MobileSortPanel, SortOption } from '../Mobile/MobileSortPanel'

export interface MobileSearchSortProps {
  isOpen: boolean
  currentSort: string
  onClose: () => void
  onSelect: (sort: string) => void
}

const COMPANY_SORT_OPTIONS: SortOption[] = [
  {
    value: 'relevance',
    label: 'Relevancy',
    arrow: null,
  },
  {
    value: 'alphabetical_asc',
    label: 'Alphabetical (A-Z)',
    arrow: null,
  },
  {
    value: 'alphabetical_desc',
    label: 'Alphabetical (Z-A)',
    arrow: null,
  },
  {
    value: 'size_desc',
    label: 'Company Size',
    arrow: 'down',
  },
  {
    value: 'size_asc',
    label: 'Company Size',
    arrow: 'up',
  },
]

export const MobileSearchSort: React.FC<MobileSearchSortProps> = (props) => {
  return <MobileSortPanel {...props} options={COMPANY_SORT_OPTIONS} />
}
